import { render, staticRenderFns } from "./ReviewMessageModal.vue?vue&type=template&id=b7caae12&scoped=true"
import script from "./ReviewMessageModal.vue?vue&type=script&lang=js"
export * from "./ReviewMessageModal.vue?vue&type=script&lang=js"
import style0 from "./ReviewMessageModal.vue?vue&type=style&index=0&id=b7caae12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7caae12",
  null
  
)

export default component.exports